export default __webpack_public_path__ + "static/media/joost_xl.2078b9a3.jpg";